import { useMutation } from "@tanstack/react-query";
import { useUploadFileMutation } from "../mutations/upload-file";
import { useCreateProjectAttachmentsMutation } from "../mutations/create-project-attachments";
import { useProject } from "../project";
import { AttachmentReferenceType } from "tekkr-common/dist/enums";

interface Input {
    files: File[];
}

interface Options {
    target?: string[];
}

export function useUploadAndAttachFilesMutation(options?: Options) {
    const { project } = useProject();
    const uploadFileMutation = useUploadFileMutation();
    const createAttachmentsMutation = useCreateProjectAttachmentsMutation();
    return useMutation({
        mutationFn: async (input: Input) => {
            const uploadedFiles = await Promise.all(
                input.files.map((f) =>
                    uploadFileMutation.mutateAsync({
                        file: f,
                    })
                )
            );
            await createAttachmentsMutation.mutateAsync({
                attachments: uploadedFiles.map((f) => ({
                    type: AttachmentReferenceType.File,
                    fileId: f.id,
                })),
                projectId: project.id,
                target: options?.target,
            });
        },
    });
}
